import { Component } from '@angular/core';
import { ReserveAction } from '../../actions/reserve.action';
import { BadgeStore } from '../../stores/badge-store';
import { AbstractPage } from '../_com/abstract-page';
import { NavController, NavParams } from 'ionic-angular';
import { ReserveDetailPage } from '../reserve/detail/reserve-detail';
import Utils from '../../_com/utils';

/**
 * Generated class for the ReserveRequestPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
	selector: 'page-reserve-request',
	templateUrl: 'reserve-request.html',
})
export class ReserveRequestPage extends AbstractPage {

	data = [];

	constructor(public navCtrl: NavController, public navParams: NavParams, private reserveAction: ReserveAction, private badgeStore: BadgeStore) {
		super();
	}

	ionViewDidEnter() {
		this.refresh();
	}

	/**
	 * リフレッシュ
	 */
	refresh() {
		this.reserveAction.getListReserveRequest().subscribe(data => {
			console.log(data);

			this.data = data.data;
			this.badgeStore.setBadgeReserveRequest(data.data.length);
		});
	}

	getType(family) {

		switch (family["type"]) {
			case "spot":
				return "スポット";
			case "month":
				return "月極";
			case "ticket":
				return "チケット";
			case "benefit":
				return "ベネフィット";
			case "ticketbenefit":
				return "チケ+ベネフィット";
			case "shiki":
				return "劇団四季";
			case "reginaclinic":
				return "レジーナクリニック";
			case "shinagawa_kinshi":
				return "品川近視";
			case "meieki_shika":
				return "名駅歯科";
			case "asada":
				return "浅田LC";
			case "menkai_koryu":
				return "面会交流";
			case "futagohoiku":
				return "ふたごほいく";
			case "hitorioyashien":
				return "ひとり親家庭支援";
			case "100minus":
				return "100円引/時";
			case "fukuri":
				return "福利厚生";
			case "ato":
				return "後請求";
			// 以降削除済みだが、過去登録データは見えるように表示は残しておく
			case "time":
				return "タイムチケット";
			case "ha":
				return "ヒューマンアカデミー";
			default:
				return "区分/未登録";
		}
	}

	/**
	 * 予約日付
	 */
	getReserveDate(d) {

		if (!d) return;
		var d = d.Reserve.datetime.date;
		return Utils.date.format(Utils.date.getDateFromHyphen(d), "M/d(EEEE)");
	}

	/**
	 * 詳細へ
	 * @param d
	 */
	goSelection(d) {
		this.navCtrl.push(ReserveDetailPage, d);
	}

	/**
	 * 「何分前」の取得
	 * @param created
	 */
	getTimeAgo(created:string){

		if (!created) return "";
		return Utils.date.getRelativeTime(created, "") + "に予約されました";
	}
}



// WEBPACK FOOTER //
// ./src/pages/reserve-request/reserve-request.ts